export function FlashLog({ entries, label = "FLASH LOG" }: { entries: string[]; label?: string }) {
  if (entries.length === 0) return null;
  return <div className="flash-log" aria-live="polite">
    <div className="flash-log-heading"><span>{label}</span><small>{entries.length} dòng</small></div>
    <div className="flash-log-list">
      {entries.slice(-8).map((entry, index) => <div className="flash-log-line" key={`${entry}-${index}`}>{entry}</div>)}
    </div>
  </div>;
}
